export enum Gender {
  male = 'male',
  female = 'female',
}

export const genderMapping = {
  [Gender.male]: $localize`:@@common_gender_male:M`,
  [Gender.female]: $localize`:@@common_gender_female:F`,
};
